export default __webpack_public_path__ + "static/media/alta-1.34078a5f.png";